import script from "./RequestMaterial.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestMaterial.vue?vue&type=script&setup=true&lang=js"

import "./RequestMaterial.vue?vue&type=style&index=0&id=44925be1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44925be1"]])

export default __exports__